import Vue from 'vue'
import i18n from './i18n.plugin'
import Snotify, { SnotifyPosition } from 'vue-snotify'
import 'vue-snotify/styles/material.css'
// import 'vue-snotify/styles/simple.css'

const options = {
  toast: {
    position: SnotifyPosition.rightTop,
    titleMaxLength: 100,
    bodyMaxLength: 300
  }
}

Vue.use(Snotify, options)
const s = new Vue()

/**
 * How to use ?
 *
 * Ex: this.$notify.success({}) // Default params
 * Ex: this.$notify.success({title: "hi", message: "hi again"})
 */
function success ({ title, message }) {
  message = message || i18n.t('success')

  s.$snotify.success(message, title, {
    timeout: 2000,
    showProgressBar: false,
    maxOnScreen: 1
  })
}

/**
 * How to use ?
 *
 * Ex: this.notifyError({title: "hi", message: "hi again"})
 *
 * Ex: // Using callback
 * this.notifyError({title: "hi", message: "hi again"}, function () {
 *    // calback is called when user confirms
 *    console.log("callback called!")
 * })
 */
function error ({ title, message }, cb) {
  s.$snotify.error(message, title, {
    timeout: 5000,
    showProgressBar: true,
    closeOnClick: false,
    pauseOnHover: true,
    icon: false,
    buttons: [
      {
        text: i18n.tc('more_details'),
        action: toast => {
          s.$snotify.remove(toast.id)
          window.open('https://docs.hsm.dinamonetworks.io/codigos-retorno/hsm_codes_pt_br#' + message)
          cb()
        }
      },
      {
        text: i18n.t('close'),
        action: toast => {
          s.$snotify.remove(toast.id)
        }
      }
    ]
  })
}

function hsmError (errorObj, err) {
  let message
  let title
  if (i18n.locale === 'pt-BR') {
  //   title = errorObj.pt.title
  //   message = errorObj.pt.message
  // } else {
  //   title = errorObj.en.title
  //   message = errorObj.en.message
  // }
    title = errorObj.code
    message = errorObj.pt.title
  } else {
    title = errorObj.code
    message = errorObj.en.title
  }
  s.$snotify.error(message, title, {
    timeout: 5000,
    showProgressBar: true,
    closeOnClick: false,
    pauseOnHover: true,
    icon: false,
    buttons: [
      {
        text: i18n.tc('more_details'),
        action: toast => {
          s.$snotify.remove(toast.id)
          window.open('https://docs.hsm.dinamonetworks.io/codigos-retorno/hsm_codes_pt_br#' + err.rd.toLowerCase())
        }
      },
      {
        text: i18n.t('close'),
        action: toast => {
          s.$snotify.remove(toast.id)
        }
      }
    ]
  })
}

/**
 * How to use ?
 *
 * Ex: this.notifyConfirm({title: "hi", message: "hi again"})
 *
 * Ex: // Using callback
 * this.notifyConfirm({title: "hi", message: "hi again"}, function () {
 *    // calback is called when user confirms
 *    console.log("callback called!")
 * })
 */
function confirm ({ title, message }, cb) {
  s.$snotify.warning(message, title, {
    closeOnClick: false,
    showProgressBar: false,
    timeout: 60000,
    // backdrop: 0.5,
    position: 'centerCenter',
    buttons: [
      {
        text: i18n.t('confirm'),
        action: (toast) => {
          cb()
          s.$snotify.remove(toast.id)
        }
      },
      {
        text: i18n.t('cancel'),
        action: (toast) => {
          s.$snotify.remove(toast.id)
        }
      }
    ]
  })
}

Vue.prototype.$notify = {
  success,
  error,
  hsmError,
  confirm
}
